import * as Yup from 'yup';
import { zipCodeNoMaskRegExp } from '../../utils/regexp';

const getAddressValidator = (ssnRequired) => {
    const addressShape = {
        zip: Yup.string().trim().matches(zipCodeNoMaskRegExp, 'Invalid format').required('Required'),
    };

    if (ssnRequired) {
        addressShape.ssn = Yup.string()
            .matches(/^\d{4}$/, 'Must be 4 digits')
            .required('SSN is required');
    }
    return Yup.object().shape(addressShape);
};

export default getAddressValidator;
